// installed dependencies
import axios from 'axios';
import {getApiHost} from './endpoints'

// component dependencies
import history from './browserHistory'
import {SLEEP_MS} from './shared/constants'
import toast from './shared/utils/toast';
import {getStoredValue} from "./shared/utils/localStorage";

//httpClient.defaults.baseURL = getApiHost(); //DEV_API_URL;
const host = getApiHost();

const httpClient = axios.create({
    baseURL: host,
    timeout: 25000,
  });


httpClient.interceptors.request.use((requestConfig) => {

    const { data } = requestConfig;
    // if (data && !data.sessionToken) {
    //     requestConfig.data.sessionToken = sessionStorage.getItem("simulcastadmin_session");
    // }
    return requestConfig;
}, error =>{
    console.log(error);
    return Promise.reject(error);
})

httpClient.interceptors.response.use(undefined, (error) => {
    if (error.message === 'Network Error' && !error.response) {
        toast.error('Network error - check if the api is running!')
        return;
    }
    const { status, data, config } = error.response;
    if (status === 404) {
        history.push('/PageNotFound')
    }

    if (status === 400 && config.method === 'get' && data.errors.hasOwnProperty('id')) {
        history.push('/PageNotFound')
    }

    if (status === 500) {
        toast.error('Server error - check logs for more info.')
    }
        throw error.response;
});

const responseBody = (response) => response.data

const sleep = (ms) => (response) => new Promise((resolve => setTimeout(() => resolve(response), ms)));

export const httpRequests = {
    get: (url) => httpClient.get(url).then(sleep(SLEEP_MS.ms)).then(responseBody),
    post: (url, body) => httpClient.post(url, body).then(sleep(SLEEP_MS.ms)).then(responseBody)
}


